import { useCallback, useState } from 'react';
import { Col, Row } from 'reactstrap';
import Table, { useTable } from 'common/components/table';

import TableActions from 'components/layouts/table';

import binIcon from 'common/assets/svg/actions/delete.svg';
import edit from 'assets/svg/actions/edit.svg';
import company from 'assets/svg/actions/company.svg';
import { useActions } from 'utils/hooks';
import CheckedButton from 'common/components/buttons/CheckedButton';

import useDrawer from 'common/components/drawer/useDrawer';
import EventTypesDrawer from './form';
import EnumsDropdown from '../Dropdown';

import * as eventTypesActions from 'store/event-types/actions';
import EventTypeBullet from '@/components/general/EventTypeBullet.jsx';

const EventTypes = () => {
  const [active, setActive] = useState(null);
  const [drawerType, setDrawerType] = useState(null);

  const drawer = useDrawer();

  const [deleteEventType] = useActions([eventTypesActions.deleteEventType]);

  const table = useTable({
    label: 'event_types',
    columns: [
      {
        header: '',
        key: 'bullet',
        sort: false,
        canFilter: false,
        minWidth: 25,
        maxWidth: 25
      },
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: true,
        canFilter: true,
        width: 3
      },
      {
        header: 'Label',
        key: 'label',
        type: 'string',
        sort: true,
        canFilter: true,
        width: 2
      },
      {
        header: 'Show on performance report',
        key: 'for_performance_reports',
        type: 'boolean',
        className: 'text-center',
        sort: false,
        canFilter: true,
        width: 2,
        options: [
          { label: 'Yes', value: 'true' },
          { label: 'No', value: 'false' }
        ]
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center',
        width: 1
      }
    ]
  });

  const onDeleteEventType = useCallback(
    async data => {
      try {
        await deleteEventType({ event_type_id: data.id });
        table.refetchData();
      } catch (e) {
        console.error(e);
      }
    },
    [deleteEventType, table]
  );

  return (
    <Row className="ld_terms-table">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions
          documentTitle="Event Types"
          title="Enums"
          className="event-types"
          dropdown={<EnumsDropdown />}
          actions={[
            { type: 'search' },
            {
              type: 'add',
              text: 'Create new',
              color: 'primary',
              onClick: () => {
                setDrawerType('editIndex');
                setActive(null);
                drawer.open();
              }
            }
          ]}
        />
      </Col>

      <Col xs={12}>
        <Table
          loader
          drawer={
            <EventTypesDrawer
              drawer={drawer}
              active={active}
              drawerType={drawerType}
              refetchData={table.refetchData}
            />
          }
          rows={{
            bullet: data => <EventTypeBullet color={data.color} />,
            for_performance_reports: data => (
              <CheckedButton
                showShadow={false}
                hideUncheckedIcon={true}
                uncheckedIconColor="violet"
                isChecked={data.for_performance_reports}
                style={{ height: 17, width: 17 }}
              />
            ),
            actions: data => ({
              options: [
                {
                  label: 'Edit Visibility',
                  icon: company,
                  onClick: (_, row) => {
                    setDrawerType('visibility');
                    setActive(row);
                    drawer.open();
                  }
                },
                {
                  label: 'Edit',
                  icon: edit,
                  onClick: (_, row) => {
                    setDrawerType('editIndex');
                    setActive(row);
                    drawer.open();
                  }
                },
                {
                  label: 'Delete',
                  icon: binIcon,
                  header: 'Delete',
                  preventionModal: true,
                  modalProps: {
                    onAccept: () => onDeleteEventType(data),
                    header: 'Delete',
                    actionText: 'Delete',
                    action: 'Delete',
                    actionHoverColor: 'delete',
                    body: (
                      <div className="text-center">
                        You are about to delete this event type. <br />
                        Are you sure you want to continue?
                      </div>
                    )
                  }
                }
              ]
            })
          }}
          {...table}
        />
      </Col>
    </Row>
  );
};

export default EventTypes;
